import { api } from "./configs/axiosConfigs"

export const SupplierAPI = {
    getSuppliers: async (data:any) => {
        const response = await api.get(
            '/supplier', { params: {...data} }
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    getSuppliersByCompany: async (data:any) => {
        const response = await api.get(
            '/supplier/listByCompany', { params: {...data} }
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    createSupplier: async (data: any) => {
        const response = await api.post(
            '/supplier/register', data
        ).then(response => response.data)
        .catch((error) => {
            console.error(error)
            return error.response.data
        })
        return response
    },
    
    editSupplier: async (idsupplier: number, data: any) => {
        const response = await api.patch(
            `/supplier/${idsupplier}`, data
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },
    
    deleteSupplier: async (idsupplier: number) => {
        const response = await api.delete(
            `/supplier/${idsupplier}`
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },
}